import { gql } from "@apollo/client";

export const UPDATE_USER = gql`
  mutation UpdateUserMutation($input: UpdateUserInput!) {
    updateUser(input: $input)
  }
`;
